import { createRouteRef } from '@backstage/frontend-plugin-api';

export const ordersRouteRef = createRouteRef();

export const orderRouteRef = createRouteRef({
  params: ['id'],
});
